/** Past newsletter issues shown on /newsletter (static until a CMS is added). */
export const NEWSLETTERS = [
  
];
